import * as req from 'api/actions';
import * as c from './constants';

export const findWallet = (payload, callback) =>
req.findPost(
  c.FIND_WALLET,
  'api/v1/administrators/wallet/inquiry',
  payload, 
  callback
);

export const viewWalletLogs = (payload, callback) =>
  req.findPost(
    c.VIEW_WALLET_LOGS,
    'api/v1/administrators/wallet/inquiry/logs',
    payload,
    callback
  );

export const updateWalletRollback = (payload, callback) =>
req.findPost(
  c.UPDATE_WALLET_ROLLBACK,
  'api/v1/administrators/wallet/rollback',
  payload,
  () => {
    if (callback) callback();
  },
);

export const viewWalletLogsForTxn = (payload, callback) =>
  req.findPost(
    c.VIEW_WALLET_LOGS_FOR_TXNID,
    'api/v1/administrators/wallet/cash_in_transaction',
    payload,
    callback
  );

export const updateWalletTxnId = (payload, callback) =>
  req.findPost(
    c.UPDATE_WALLET_TXN_ID,
    'api/v1/administrators/wallet/cash_in_transaction',
    payload,
    callback
  );

  export const cashOut = (payload, callback) =>
  req.create(
    c.CASH_OUT,
    'api/v1/administrators/wallet/cashout',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
